export function ConfigBlock({
  title,
  children,
}: {
  title?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="bg-linear-to-b from-[#1F1F22] to-[#131519] p-4 rounded-xl flex flex-col items-center gap-2 whitespace-nowrap w-[210px]">
      <div className="font-medium text-xs text-text-secondary">{title}</div>
      {children}
    </div>
  );
}
